import React from "react";
import { Redirect } from "react-router-dom";

import "../../styles/errors.scss";

class Error404 extends React.Component {
  constructor() {
    super();

    this.state = {
      redirect: false,
    };
  }

  render() {
    const { redirect } = this.state;

    return (
      <div>
        {redirect ? (
          <Redirect to="/home" />
        ) : (
          <div className="error-page">
            <h1>404 Error</h1>
            <div className="center-box">
              <p>
                <b>Page Not Found</b>
              </p>
              <p>
                Oops! It looks like the page you want
                <br /> isn't here anymore.
              </p>
              <button
                className="btn btn-default"
                style={{ width: "320px" }}
                onClick={() => this.setState({ redirect: true })}
              >
                Go to Homepage
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Error404;
